var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigures1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M358.79 400.89L275.39 317.5C384.19 208.7 444.64 148.25 456.73 136.16C280.24 -40.32 0.97 85.74 0 315.56C0 315.56 0 315.56 0 315.56C0.97 378.59 18.42 434.83 60.12 485.25C95.03 527.92 143.52 559.92 199.76 573.5C199.76 573.5 199.76 573.5 199.76 573.5C251.15 585.13 298.67 585.13 351.03 566.71C443.15 604.53 552.73 590.95 638.06 510.47C625.71 497.28 563.98 431.34 452.85 312.65L358.79 400.89ZM263.76 308.77C90.18 313.62 144.48 311.68 14.55 315.56C16.48 98.35 277.33 -14.14 435.39 136.16C401.07 170.69 280.92 291.51 263.76 308.77ZM255.03 323.32C205.58 542.47 216.24 495.92 201.7 559.92C97.94 532.77 20.36 441.62 14.55 330.1C62.64 328.75 230.98 323.99 255.03 323.32ZM269.58 331.07C274.88 336.37 301.38 362.88 349.09 410.59C292.65 463.53 261.3 492.95 255.03 498.83C276.36 522.1 298.67 541.5 332.61 557.98C293.82 568.65 255.03 570.59 217.21 562.83C228.85 511.44 219.15 552.16 269.58 331.07ZM451.88 333.98C551.37 439.87 606.64 498.7 617.7 510.47C518.79 597.74 367.52 592.89 275.39 499.8C298.93 477.69 357.75 422.42 451.88 333.98Z",
    id: "bRbHHPcWq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.56 216.08C213.56 231.59 222.29 244.2 238.77 244.2C255.26 244.2 263.98 231.59 263.98 216.08C263.98 200.56 255.26 187.96 238.77 187.96C222.29 187.96 213.56 200.56 213.56 216.08ZM224.23 217.05C224.23 207.35 229.07 199.59 238.77 199.59C248.47 199.59 253.32 207.35 253.32 217.05C252.35 225.77 248.47 234.5 238.77 234.5C229.07 234.5 224.23 225.77 224.23 217.05Z",
    id: "a632ELJR4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.77 129.77C158.29 129.77 149.56 142.38 149.56 157.9C149.56 173.41 157.32 186.02 174.77 186.02C192.23 186.02 199.98 173.41 199.98 157.9C199.98 142.38 191.26 129.77 174.77 129.77ZM175.74 140.44C185.44 140.44 190.29 148.2 190.29 157.9C190.29 167.59 185.44 175.35 175.74 175.35C166.04 175.35 161.2 167.59 161.2 157.9C161.2 148.2 166.04 140.44 175.74 140.44Z",
    id: "a1uyV2RY7x"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.89 133.65C228.59 143.83 178.17 225.29 171.86 235.47C170.89 237.41 170.89 240.32 172.83 242.26C175.74 245.17 179.62 244.2 181.56 241.29C187.67 231.11 236.54 149.65 242.65 139.47C244.59 136.56 244.59 133.65 242.65 132.68C240.71 130.74 236.83 130.74 234.89 133.65Z",
    id: "a17nch7MEP"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bRbHHPcWq",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bRbHHPcWq",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a632ELJR4",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a632ELJR4",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1uyV2RY7x",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1uyV2RY7x",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a17nch7MEP",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a17nch7MEP",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigures1);
export default __webpack_public_path__ + "static/media/figures-1.79ec157c2be3f2a9731746aa72ec4e57.svg";
export { ForwardRef as ReactComponent };